var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"product-item",class:{ 'product-item--small': _vm.small },style:({ 'background-image': ("url(" + (_vm.getBackgroundImage()) + ")") }),attrs:{"to":{ 
        name: 'catalog.product', 
        params: { 
            'category': _vm.currentCategorySlug, 
            'subcategory': _vm.currentSubCategorySlug, 
            'product': _vm.product.slug 
        }
    }}},[_c('div',{staticClass:"product-item__title"},[_vm._v("\n        "+_vm._s(_vm.product.title)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }